// extracted by mini-css-extract-plugin
export default {"checkbox":"Payment_checkbox__r-jFk"};